import { WebCitationItem } from "../components/Answer/WebCitations";

export async function writeClipboardText(text: string): Promise<void> {
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
    }

    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
}

export interface ConversationTurn {
    question: string;
    assistantText: string;
    citations?: WebCitationItem[];
}

export function buildConversationTranscript(turns: ConversationTurn[]): string {
    return turns
        .map(({ question, assistantText, citations }) => {
            const formatCitation = (item: WebCitationItem) => {
                const label = item.source || item.url || "Source";
                const urlPart = item.url ? ` (${item.url})` : "";
                return `${label}${urlPart}`;
            };
            const citationLines = (citations || []).map(formatCitation).filter(Boolean);
            const sourcesBlock = citationLines.length
                ? "Sources:\n" + citationLines.map(line => `- ${line}`).join("\n")
                : "";
            return [`User: ${question}`, `Assistant: ${assistantText.trim()}`, sourcesBlock].filter(Boolean).join("\n");
        })
        .join("\n\n");
}
